import { safetyInsightRows, SAFETY_INSIGHTS_NOTE } from '../utils/safetyInsights';

export default function SafetyInsights({ insights }) {
  const rows = safetyInsightRows(insights);
  return (
    <div className="panel" style={{ marginTop: 18 }}>
      <div className="panel-header"><div><h3>Safety program overview</h3><p className="panel-subtitle">Recorded driving performance and driver participation, with supporting detail for follow-up.</p></div></div>
      <div className="panel-body">
        {rows.length ? <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 18 }}>
          {rows.slice(0, 2).map(([label, value, detail]) => <div key={label}>
            <div>{label}</div><strong style={{ fontSize: 24 }}>{value}</strong><p className="hint" style={{ margin: '4px 0 0' }}>{detail}</p>
          </div>)}
        </div> : <p className="hint">Safety insights are not available for this report yet.</p>}
        {rows.length > 0 && <>
          <h4 style={{ marginTop: 24 }}>Supporting event and follow-up detail</h4>
          <div style={{ overflowX: 'auto' }}><table className="data-table"><thead><tr><th>Measure</th><th>Recorded result</th><th>Definition</th></tr></thead><tbody>
            {rows.slice(2).map(([label, value, detail]) => <tr key={label}><td>{label}</td><td>{value}</td><td>{detail}</td></tr>)}
          </tbody></table></div>
        </>}
        <p className="hint" style={{ marginBottom: 0 }}>{SAFETY_INSIGHTS_NOTE}</p>
      </div>
    </div>
  );
}
